export function isIpAddress(ipAddress) {
    if (!/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/g.test(ipAddress)) {
        return false;
    }
    return ipAddress.split('.').every((byte) => parseInt(byte) < 256);
}
